var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Switch",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3377",
    "data-name": "Rectangle 3377",
    width: 20,
    height: 20,
    fill: "#1b453e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3560",
    "data-name": "Group 3560",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M19.91,6.041a4,4,0,0,0-3.961-3.162l-4.779,0H2.19L3.454,1.624l.281-.278c.19-.188.37-.365.544-.542L4.29.793,4.274.776C4,.5,3.748.247,3.506.008L3.5,0l0,0C2.478,1.017,1.392,2.1,0,3.5c1.181,1.183,2.339,2.343,3.5,3.5.283-.271.563-.557.8-.8-.01-.011-.019-.025-.034-.04L3.8,5.694c-.073-.073-.213-.216-.287-.288L2.225,4.115H15.877a2.754,2.754,0,0,1,2.884,2.754c0,.088.045.242.174.26a3.131,3.131,0,0,0,.436.029,3.812,3.812,0,0,0,.464-.029c.024,0,.082-.01.165-.188v-.42L19.978,6.4c-.022-.126-.043-.245-.069-.357",
    fill: "#1b453e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M.09,193.737A4,4,0,0,0,4.051,196.9l4.779,0h8.98l-1.264,1.254-.281.278c-.19.188-.37.365-.544.542l-.011.011.015.016c.274.278.526.53.769.769l.008.008,0,0c1.016-1.013,2.1-2.1,3.494-3.492-1.181-1.183-2.339-2.343-3.5-3.5-.283.271-.563.557-.8.8.01.011.019.025.034.04l.459.459c.073.073.213.216.287.288l1.29,1.292H4.123a2.754,2.754,0,0,1-2.884-2.754c0-.088-.045-.242-.174-.26a3.131,3.131,0,0,0-.436-.029,3.811,3.811,0,0,0-.464.029c-.024,0-.082.01-.165.188v.42l.022.122c.022.126.043.245.069.357",
    transform: "translate(0 -179.779)",
    fill: "#1b453e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/Switch.8a99d0e3656ba61cea13fbeff341a54b.svg";
export { ForwardRef as ReactComponent };